export const VoucherSteps = {
  NONE: 'none',
  OPTIONS: 'options',
  METHODS: 'methods',
  FIELDS: 'fields',
  BANKS: 'banks',
  REDEEM: 'redeem'
} as const
